export const completedRenewalsReportFields = [
  {
    label: 'customer_name',
    value: 'customerName'
  },
  {
    label: 'customer_number',
    value: 'customerNumber'
  },
  {
    label: 'branch_code',
    value: 'branchCode'
  },
  {
    label: 'route_number',
    value: 'routeNumber'
  },
  {
    label: 'district_code',
    value: 'districtCode'
  },
  {
    label: 'rsr_name',
    value: 'csrName'
  },
  {
    label: 'proposed_by',
    value: 'proposedBy'
  },
  {
    label: 'employee_role',
    value: 'role'
  },
  {
    label: 'branch_margin_rating',
    value: 'branchMarginRating'
  },
  {
    label: 'classification',
    value: 'classification'
  },
  {
    label: 'completed_date',
    value: 'absDate'
  }
];

export const mcReportFields = [
  {
    label: 'branch_code',
    value: 'branchCode'
  },
  {
    label: 'district_code',
    value: 'districtCode'
  },
  {
    label: 'route_number',
    value: 'routeNumber'
  },
  {
    label: 'total_proposed',
    value: 'totalProposed'
  },
  {
    label: 'total_completed',
    value: 'totalCompleted'
  },
  {
    label: 'total_within_mad',
    value: 'totalWithinMad'
  },
  {
    label: 'total_csr_proposed',
    value: 'totalCsrProposed'
  },
  {
    label: 'total_csr_completed',
    value: 'totalCsrCompleted'
  },
  {
    label: 'total_csr_within_mad',
    value: 'totalCsrWithinMad'
  },
  {
    label: 'total_dm_proposed',
    value: 'totalDmProposed'
  },
  {
    label: 'total_dm_completed',
    value: 'totalDmCompleted'
  },
  {
    label: 'total_dm_within_mad',
    value: 'totalDmWithinMad'
  },
  {
    label: 'total_other_proposed',
    value: 'totalOtherProposed'
  },
  {
    label: 'total_other_completed',
    value: 'totalOtherCompleted'
  },
  {
    label: 'total_other_within_mad',
    value: 'totalOtherWithinMad'
  }
];

export const noDeviationReportFields = [
  {
    label: 'branch_code',
    value: 'branchCode'
  },
  {
    label: 'customer_number',
    value: 'customerNumber'
  },
  {
    label: 'customer_name',
    value: 'customerName'
  },
  {
    label: 'completed_date',
    value: 'absDate'
  },
  {
    label: 'route_number',
    value: 'routeNumber'
  },
  {
    label: 'district_code',
    value: 'districtCode'
  },
  {
    label: 'proposed_by',
    value: 'proposedBy'
  },
  {
    label: 'proposed_by',
    value: 'proposedById'
  },
  {
    label: 'classification',
    value: 'classification'
  },
  {
    label: 'previous_CXD',
    value: 'previousCXD'
  },  
  {
    label: 'new_CXD',
    value: 'newCXD'
  }
];